(function() {
	'use strict';

	$('.js-bundle-select').on('change', function() {
		var id = this.id;
		var elements = document.body.querySelectorAll('[data-controlled-by="' + id + '"]');
		var activeElement = document.body.querySelector('[data-controlled-by="' + id + '"][data-maintenance="' + this.value + '"]');

		elements.forEach(function(el) {
			el.classList.add('d-none');
		});

		activeElement.classList.remove('d-none');
	});
})();
